import React from "react";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import MenuIcon from "@mui/icons-material/MenuRounded";
import LogoutIcon from "@mui/icons-material/LogoutRounded";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDownRounded";
import { CDropdown, CDropdownToggle, CDropdownMenu, CDropdownItem } from "@coreui/react";
import "./navbar.scss";
import { logout } from "../../HigherOrderComponents/ApiCalls/authentication/Logout";
import ThemeToggle from "../ui/ThemeToggle";

const Navbar = () => {
  const dispatch = useDispatch();
  const sidebarShow = useSelector((state) => state.sidebarShow);
  const adminDetail = useSelector((state) => state.adminDetails);
  const navigate = useNavigate();

  const handleLogOut = async () => {
    // JWTs are stateless on the new backend — logout is client-side only.
    await logout();
    localStorage.removeItem("sparrowSignIn");
    dispatch({ type: "setAdmin", adminDetails: null });
    navigate("/login");
  };

  const initials = `${adminDetail?.first_name?.[0] || ""}${adminDetail?.last_name?.[0] || ""}`.toUpperCase() || "A";
  const displayName = adminDetail?.first_name
    ? `${adminDetail.first_name} ${adminDetail.last_name ? adminDetail.last_name.charAt(0).toUpperCase() + "." : ""}`.trim()
    : "Admin";

  return (
    <header className="sp-navbar">
      <button
        type="button"
        className="sp-navbar__menu"
        onClick={() => dispatch({ type: "set", sidebarShow: !sidebarShow })}
        aria-label="Toggle sidebar"
      >
        <MenuIcon />
      </button>

      <div className="sp-navbar__spacer" />

      <div className="sp-navbar__actions">
        <ThemeToggle />

        <CDropdown variant="nav-item" className="sp-profile">
          <CDropdownToggle className="sp-profile__toggle" caret={false}>
            <span className="sp-profile__avatar">{initials}</span>
            <span className="sp-profile__name">{displayName}</span>
            <KeyboardArrowDownIcon className="sp-profile__chev" />
          </CDropdownToggle>
          <CDropdownMenu className="sp-profile__menu" placement="bottom-end">
            <CDropdownItem onClick={handleLogOut} className="sp-profile__item">
              <LogoutIcon className="me-2" /> Log out
            </CDropdownItem>
          </CDropdownMenu>
        </CDropdown>
      </div>
    </header>
  );
};

export default Navbar;
